<template>
  <input type="text" class="form-control" @keydown.up.prevent="increment" @keydown.down.prevent="decrement"
         :value="active?val:formatted" @blur="update" @keyup.enter.stop="update" @focus="active = true" @change="onChange">
</template>

<script>

function formatAsCurrency (value, dec) {
  dec = dec || 0
  return value.toFixed(dec).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
}

export default {
  name: 'CurrencyInput',
  props: {
    value: {type: Number, default: 0},
    min: {type: Number, default: 0},
    max: {type: Number, default: 100000000000},
    step: {type: Number, default: 1000},
    decimals: {type: Number, default: 0},
    type: {default: 'currency'}
  },
  data: function () {
    return {
      active: false,
      dValue: null
    }
  },
  computed: {
    val: function () {
      if (this.type === 'currency') {
        return Number(this.value) + ''
      } else if (this.type === 'years') {
        return Number(this.value) + ''
      } else if (this.type === 'percent') {
        return Number(this.value * 100).toFixed(3)
      }
    },
    formatted: function () {
      if (this.type === 'currency') {
        return formatAsCurrency(this.value, 0)
      } else if (this.type === 'years') {
        return Number(this.value + ''.replace(/[^0-9]+/g, '')) + ' Years'
      } else if (this.type === 'percent') {
        return (this.value * 100).toFixed(this.decimals) + '%'
      }
    }
  },
  methods: {
    increment: function (e) {
      if (e.shiftKey) {
        this.dValue += 10 * this.step
      } else {
        this.dValue += this.step
      }
      if (this.value > this.max) {
        this.dValue = this.max
      }
      this.changed()
    },
    decrement: function (e) {
      if (e.shiftKey) {
        this.dValue -= 10 * this.step
      } else {
        this.dValue -= this.step
      }
      if (this.value < this.min) {
        this.dValue = this.min
      }
      this.changed()
    },
    update: function () {
      this.active = false
      var tempVal = this.$el.value + ''
      this.dValue = Number(tempVal.replace(/[^0-9]+/g, ''))
      if (this.type === 'percent') this.dValue /= 100
      this.changed()
    },
    changed: function () {
      this.$emit('input', Number(this.dValue))
    },
    onChange (event) {
      this.$emit('change', Number(event.target.value))
    },
  },
  mounted () {
    this.dValue = this.value
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CurrencyInput.vue